import React from 'react';
import PropTypes from 'prop-types';

import {
  eBarSendDailyReportMail,
  eBarSendWeeklyReportMail,
  eBarSendTestEmails,
} from '@services/EBarManageEmails';

import Input from '@style-guide/components/Input';
import LoadingOverlay from '@components/LoadingOverlay';
import YellowLineSVG from '@style-guide/svg/YellowLineSVG';
import Button from '@style-guide/components/Button';
import RadioButton from '@style-guide/components/RadioButton';
import PopUpModal from './components/PopUpModal/PopUpModal';
import BlockWrapper from './components/BlockWrapper';
import ButtonWrapper from './components/ButtonWrapper';
import BodyDiv from './components/BodyDiv';
import HeaderDiv from './components/HeaderDiv';
import Title from './components/Title';
import Wrapper from './components/Wrapper';
import MessageModalBody from './components/MessageModalBody';


/**
# EBar ManageEmailsCTA
A CTA containing list of links to OSBA Member Center Information items.
 */
class EBarManageEmailsCTA extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      headingState: this.props.heading,
      showMessagePopUp: false,
      showEmailErrorMessage: false,
      messagePopUpTitle: '',
      dailyWeekly: 'Daily',
      testEmailId: '',
    };

    this.onClickCloseCancel = this.onClickCloseCancel.bind(this);
    this.onChangeRadioButton = this.onChangeRadioButton.bind(this);
    this.onClickSend = this.onClickSend.bind(this);
    this.onTestClickSend = this.onTestClickSend.bind(this);
    this.saveTestEmail = this.saveTestEmail.bind(this);
  }

  onClickCloseCancel() {
    this.setState({
      showMessagePopUp: false,
      messagePopUpTitle: '',
    });
  }

  onChangeRadioButton(e) {
    this.setState({
      dailyWeekly: e.target.value,
    });
  }

  onClickSend() {
    this.setState({
      loading: true,
      showMessagePopUp: false,
      messagePopUpTitle: '',
    });
    if (this.state.dailyWeekly === 'Daily') {
      eBarSendDailyReportMail()
        .then(() => {
          this.setState({
            loading: false,
            showMessagePopUp: true,
            messagePopUpTitle: 'Daily Report Mail Job Started !!',
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            showMessagePopUp: true,
            messagePopUpTitle: 'Daily Report Mail Job Failed !!',
          });
        });
    } else if (this.state.dailyWeekly === 'Weekly') {
      eBarSendWeeklyReportMail()
        .then(() => {
          this.setState({
            loading: false,
            showMessagePopUp: true,
            messagePopUpTitle: 'Weekly Report Mail Job Started !!',
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            showMessagePopUp: true,
            messagePopUpTitle: 'Weekly Report Mail Job Failed !!',
          });
        });
    }
  }

  onTestClickSend() {
    this.setState({
      loading: true,
      showMessagePopUp: false,
      messagePopUpTitle: '',
    });
    eBarSendTestEmails(this.state.dailyWeekly, this.state.testEmailId)
      .then(() => {
        this.setState({
          loading: false,
          testEmailId: '',
          showMessagePopUp: true,
          messagePopUpTitle: 'Test Email Sent',
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          testEmailId: '',
          showMessagePopUp: true,
          messagePopUpTitle: 'Test Email failed !!',
        });
      });
  }

  saveTestEmail(event) {
    this.setState({
      testEmailId: event.target.value,
    });

    const regEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEmail.test(event.target.value) && event.target.value.length > 0) {
      this.setState({
        showEmailErrorMessage: true,
      });
    } else {
      this.setState({
        showEmailErrorMessage: false,
      });
    }
  }

  render() {
    const {
      loading,
      headingState,
      showMessagePopUp,
      showEmailErrorMessage,
      messagePopUpTitle,
    } = this.state;

    return (
      <BlockWrapper>
        {loading && <LoadingOverlay />}
        {showMessagePopUp && messagePopUpTitle && (
          <PopUpModal
            dismissable={false}
            body={(
              <MessageModalBody
                title={messagePopUpTitle}
                okFunction={this.onClickCloseCancel}
              />
            )}
            closeAction={this.onClickCloseCancel}
          />
        )}
        <Wrapper>
          <YellowLineSVG />
          <HeaderDiv>
            <Title>{!headingState ? 'Manage Emails' : headingState}</Title>
          </HeaderDiv>
          <BodyDiv>
            <ButtonWrapper>
              <RadioButton
                label="Daily"
                value="Daily"
                onChange={this.onChangeRadioButton}
                isChecked={this.state.dailyWeekly === 'Daily'}
                id="daily"
                name="weekly"
              />
              <RadioButton
                label="Weekly"
                value="Weekly"
                onChange={this.onChangeRadioButton}
                isChecked={this.state.dailyWeekly === 'Weekly'}
                id="weekly"
                name="weekly"
              />
            </ButtonWrapper>
            <ButtonWrapper>
              <Button
                onClick={() => this.onClickSend()}
              >
                Send
              </Button>
            </ButtonWrapper>
          </BodyDiv>
          <BodyDiv>
            <Input
              id="emailInput"
              type="text"
              placeholder="Email"
              label="Send Test Email"
              onChange={this.saveTestEmail}
              value={this.state.testEmailId}
            />
            &nbsp;
            <ButtonWrapper>
              <Button
                disabled={!this.state.testEmailId || this.state.showEmailErrorMessage}
                onClick={this.onTestClickSend}
              >
                Send
              </Button>
            </ButtonWrapper>
          </BodyDiv>
          {showEmailErrorMessage && (<p>Invalid Email!!</p>)}
        </Wrapper>
      </BlockWrapper>
    );
  }
}

EBarManageEmailsCTA.propTypes = {
  heading: PropTypes.string,
};

EBarManageEmailsCTA.defaultProps = {
  heading: 'EBar Manage Emails',
};


EBarManageEmailsCTA.displayName = 'EBarManageEmailsCTA';

export default EBarManageEmailsCTA;
